import { render } from "./MessagesEmpty.vue?vue&type=template&id=24ce8088&ts=true"
import script from "./MessagesEmpty.vue?vue&type=script&lang=ts"
export * from "./MessagesEmpty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Messages/MessagesEmpty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24ce8088"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24ce8088', __exports__)) {
    api.reload('24ce8088', __exports__)
  }
  
  module.hot.accept("./MessagesEmpty.vue?vue&type=template&id=24ce8088&ts=true", () => {
    api.rerender('24ce8088', render)
  })

}


export default __exports__